var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import Container from '@telia-front/container';
import Notice from '@telia-front/notice';
const HeaderOverlayNotice = (props) => {
    const noticeRef = React.useRef(null);
    const { notice } = props, rest = __rest(props, ["notice"]);
    const { type = 'info' } = notice, noticeRest = __rest(notice, ["type"]);
    const getNoticeHeight = () => {
        if (noticeRef.current) {
            return noticeRef.current.offsetHeight;
        }
    };
    const [noticeWrapperHeight, setNoticeWrapperHeight] = React.useState(getNoticeHeight());
    const overlayNoticeBEM = () => {
        const classArray = ['header__overlay-notice'];
        return classArray.join(' ');
    };
    const overLayNoticeWrapperBEM = () => {
        const classArray = ['header__overlay-notice-wrapper'];
        return classArray.join(' ');
    };
    return (React.createElement(CSSTransition, Object.assign({}, rest, { onEnter: () => setNoticeWrapperHeight(0), onEntering: () => setNoticeWrapperHeight(getNoticeHeight()), onEntered: () => setNoticeWrapperHeight(undefined), onExit: () => setNoticeWrapperHeight(getNoticeHeight()), onExiting: () => setNoticeWrapperHeight(0) }),
        React.createElement("div", { className: overLayNoticeWrapperBEM(), style: { height: noticeWrapperHeight } },
            React.createElement("div", { className: overlayNoticeBEM(), ref: noticeRef },
                React.createElement(Container, null,
                    React.createElement(Notice, Object.assign({ align: "center", type: type, fullWidth: true }, noticeRest)))))));
};
export default HeaderOverlayNotice;
